<template>
	<div id="group_application_letter_outer">
		<div v-if="user != null">
			<div class="iconfont close-button" @click="closeButtonClicked">&#xe639;</div>

			<div id="group_application_letter">
				<div style="font-size: 12px;">会员编号：____________________</div>

				<div>{{user.name}}</div>

			</div>
			
		</div>
	</div>
</template>

<script>
export default {
	name: 'TestView',
	props: {
		user: {
			default: ()=> null,
		}
	},
	data () {
		return {

		}
	},
	computed: {

	},

	mounted() {

	},
	methods: {
		closeButtonClicked() {
			this.$emit("close");
		}
	}
}
	
</script>

<style scoped>

	#group_application_letter_outer {
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.3);
		position: fixed;
		left: 0;
		top: 0;
		z-index: 999;

		display: flex;
		flex-wrap: nowrap;
		justify-content: center;
		align-items: center;
	}

	#group_application_letter_outer > div {
		background-color: white;
		width: 90%;
		height: 90%;
		position: relative;
		/*width: 1192px;*/
		/*max-width: 1192px;*/
		border: solid 1px #000;
		overflow: auto;
	}

	#group_application_letter {
		padding: 180px 160px;
		width: 1192px;
	}

	#group_application_letter_outer .close-button {
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 1.5rem;
    font-weight: bold;
    z-index: 99;
  }
	
</style>


// WEBPACK FOOTER //
// src/components/group/groupApplicationVues/TestView.vue